import { render, staticRenderFns } from "./OfficialSeedDetailsForm.vue?vue&type=template&id=0991ce0a&scoped=true&"
import script from "./OfficialSeedDetailsForm.vue?vue&type=script&lang=js&"
export * from "./OfficialSeedDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./OfficialSeedDetailsForm.vue?vue&type=style&index=0&id=0991ce0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0991ce0a",
  null
  
)

export default component.exports